import TitleText from "app/containers/Auth/components/TitleText";
import { useQueryState } from "nuqs";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentDialog from "../../components/PaymentDialog";
import {
  selectTeamForm,
  selectTeamFormActiveIndex,
} from "../../redux/selector";
import { actions } from "../../redux/slice";
import { PLAN_TYPE } from "../../types";
import LoaderOverlay from "./components/LoaderOverlay";
import TabNavigation from "./components/TabNavigation";
import FormOne from "./containers/FormOne";
import FormThree from "./containers/FormThree";
import FormTwo from "./containers/FormTwo";
import Pricing from "./containers/Pricing";

export default function TeamOnBoarding() {
  const activeIndex = useSelector(selectTeamFormActiveIndex);
  const [checkout, setCheckout] = useQueryState("checkout");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const form = useSelector(selectTeamForm);
  const isOnboardingTeamPage = location.pathname === "/onboarding/team";

  const onNext = () => {
    if (activeIndex < 4) {
      if (activeIndex === 2) {
        dispatch(
          actions.createTeamProject({
            callback: () => {
              dispatch(actions.clearTeamProjectForm());
              dispatch(actions.setTeamFormActiveIndex(activeIndex + 1));
            },
          })
        );
      } else if (activeIndex === 3) {
        dispatch(
          actions.createProjectMember({
            callback: () => {
              dispatch(actions.clearTeamForm());
              dispatch(actions.setTeamFormActiveIndex(1));
              navigate("/onboarding/welcome?callback=/app/home");
            },
          })
        );
      } else {
        dispatch(actions.setTeamFormActiveIndex(activeIndex + 1));
      }
    } else {
      dispatch(
        actions.saveTeamRequest({
          callback: () => navigate("/app/home"),
        })
      );
    }
  };
  const onBack = () => {
    if (activeIndex > 1) {
      dispatch(actions.setTeamFormActiveIndex(activeIndex - 1));
    }
  };
  const onComplete = (plan: PLAN_TYPE) => {
    dispatch(
      actions.setTeamPlan({
        value: plan,
      })
    );
  };

  return (
    <div className="container min-h-[580px] flex flex-col justify-start max-w-[770px]">
      {form?.isProjectCreated && <LoaderOverlay />}
     
      {isOnboardingTeamPage && <TitleText title=" Create new team" />}
      <TabNavigation activeIndex={activeIndex} />
      {activeIndex === 1 && (
        <FormOne
          onProceed={onNext}
          isOnboardingTeamPage={isOnboardingTeamPage}
        />
      )}
      {activeIndex === 2 && (
        <FormTwo
          onProceed={onNext}
          onBack={onBack}
          isOnboardingTeamPage={isOnboardingTeamPage}
        />
      )}
      {activeIndex === 3 && (
        <FormThree
          onProceed={onNext}
          isOnboardingTeamPage={isOnboardingTeamPage}
        />
      )}
      {activeIndex === 4 && <Pricing onProceed={(plan) => setCheckout(plan)} />}
      {activeIndex === 4 && checkout && (
        <PaymentDialog
          onProceed={() => onComplete(checkout as PLAN_TYPE)}
          onClose={() => setCheckout(null)}
        />
      )}
    </div>
  );
}
